<template>
  <div class="age-gender-chart">
    <!-- 年龄分布环形图 -->
    <div class="age-chart-container">
      <div id="ageChart" class="age-chart"></div>
    </div>
    
    <!-- 性别比例 -->
    <div class="gender-ratio">
      <div class="gender-item">
        <div class="gender-icon male">
          <span class="gender-symbol">♂</span>
        </div>
        <div class="gender-info">
          <div class="gender-percent">{{ maleRatio }}%</div>
          <div class="gender-label">男性占比</div>
        </div>
      </div>
      <div class="gender-item">
        <div class="gender-icon female">
          <span class="gender-symbol">♀</span>
        </div>
        <div class="gender-info">
          <div class="gender-percent">{{ femaleRatio }}%</div>
          <div class="gender-label">女性占比</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import resize from "@/components/Charts/mixins/resize";

export default {
  name: 'AgeGenderChart',
  mixins: [resize],
  data() {
    return {
      chart: null,
      maleRatio: 52,
      femaleRatio: 48,
      // 示例年龄分布数据
      ageData: [
        { name: '60岁+', value: 25 }, // 深蓝色
        { name: '50岁+', value: 20}, // 浅绿色
        { name: '0岁+', value: 15 }, // 黄色
        { name: '40岁+', value: 18}, // 红色
        { name: '10岁+', value: 22}  // 浅蓝色
      ]
    }
  },
  mounted() {
    this.initAgeChart()
    this.getGenderRatio()
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initAgeChart() {
      this.$nextTick(() => {
        const chartDom = document.getElementById('ageChart')
        if (!chartDom) return
        
        this.chart = echarts.init(chartDom, 'dark')
        
        const option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            borderColor: '#74ffbe',
            borderWidth: 1,
            textStyle: {
              color: '#fff'
            }
          },
          // 颜色配置：橙色、黄色、紫色、红色、青色、绿色等
          color: ['#60fcb2', '#f20eb5', '#7d0ef2', '#0ed0f2', '#0ef237', '#cdf20e', '#f4ad24', '#ec3f16'],
          series: [
            {
              name: '年龄分布',
              type: 'pie',
              radius: ['15%', '75%'],
              center: ['50%', '50%'],
              roseType: 'area',
              avoidLabelOverlap: true,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#080A20',
                borderWidth: 2
              },
              label: {
                show: true,
                position: 'outside',
                formatter: '{b}',
                fontSize: 12,
                color: '#74ffbe',
                fontWeight: 'normal',
                distance: 10
              },
              labelLine: {
                show: true,
                length: 20,
                length2: 15,
                lineStyle: {
                  color: '#74ffbe',
                  width: 1,
                  type: 'solid'
                },
                smooth: 0.3
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 15,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(116, 255, 190, 0.6)',
                  borderWidth: 0
                },
                label: {
                  show: true,
                  fontSize: 14,
                  fontWeight: 'bold',
                  color: '#74ffbe'
                }
              },
              data: this.ageData.map((item) => ({
                ...item,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#080A20',
                  borderWidth: 0
                }
              }))
            }
          ]
        }
        
        this.chart.setOption(option)
        
        // 响应式调整
        window.addEventListener('resize', () => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      })
    },
    getGenderRatio() {
      // 这里可以调用接口获取性别比例数据
      // 暂时使用示例数据
      // this.$http.post(process.env.VUE_APP_API_HOST + "/patient_gender_pie", {
      //   "extra_params": {}
      // }).then((res) => {
      //   const data = res.data.data || []
      //   let total = 0
      //   data.forEach(item => {
      //     total += item.value
      //   })
      //   data.forEach(item => {
      //     if (item.name === '男') {
      //       this.maleRatio = Math.round((item.value / total) * 100)
      //     } else if (item.name === '女') {
      //       this.femaleRatio = Math.round((item.value / total) * 100)
      //     }
      //   })
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.age-gender-chart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;

  .age-chart-container {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;

    #ageChart {
      width: 100%;
      height: 100%;
      min-height: 200px;
    }
  }

  .gender-ratio {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    padding: 15px 0;
    flex-shrink: 0;

    .gender-item {
      display: flex;
      align-items: center;
      gap: 10px;

      .gender-icon {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: bold;

        &.male {
          background-color: rgba(72, 219, 251, 0.3);
          color: #48dbfb;
        }

        &.female {
          background-color: rgba(255, 159, 243, 0.3);
          color: #ff9ff3;
        }

        .gender-symbol {
          line-height: 1;
        }
      }

      .gender-info {
        display: flex;
        flex-direction: column;

        .gender-percent {
          font-size: 18px;
          font-weight: 600;
          color: #74ffbe;
          line-height: 1.2;
        }

        .gender-label {
          font-size: 12px;
          color: #999;
          line-height: 1.2;
          margin-top: 2px;
        }
      }
    }
  }
}
</style>

